import { createAction, createErrorAction } from '../../../helpers';
import { ErrorResponse } from '../../../../@types';
import { SharePointTypes } from '../../../../@types/enums/redux/store';
import { Site, Drive } from './initialState';

export const sharepointSettingsRequest = () =>
  createAction(SharePointTypes.SHAREPOINT_SETTINGS_REQUEST);

export const sharepointSettingsSuccess = (payload: any) =>
  createAction(SharePointTypes.SHAREPOINT_SETTINGS_SUCCESS, payload);

export const sharepointSettingsFailure = <E extends ErrorResponse>(error: E) =>
  createErrorAction(SharePointTypes.SHAREPOINT_SETTINGS_FAILURE, error);

export const sharepointSitesRequest = () =>
  createAction(SharePointTypes.SHAREPOINT_SITES_REQUEST);

export const sharepointSitesSuccess = (payload: Site[]) =>
  createAction(SharePointTypes.SHAREPOINT_SITES_SUCCESS, payload);

export const sharepointSitesFailure = <E extends ErrorResponse>(error: E) =>
  createErrorAction(SharePointTypes.SHAREPOINT_SITES_FAILURE, error);

export const sharepointDrivesRequest = () =>
  createAction(SharePointTypes.SHAREPOINT_DRIVES_REQUEST);

export const sharepointDrivesSuccess = (payload: Drive[]) =>
  createAction(SharePointTypes.SHAREPOINT_DRIVES_SUCCESS, payload);

export const sharepointDrivesFailure = <E extends ErrorResponse>(error: E) =>
  createErrorAction(SharePointTypes.SHAREPOINT_DRIVES_FAILURE, error);

export const sharepointSaveRequest = () =>
  createAction(SharePointTypes.SHAREPOINT_SAVE_REQUEST);

export const sharepointSaveSuccess = (payload: any) =>
  createAction(SharePointTypes.SHAREPOINT_SAVE_SUCCESS, payload);

export const sharepointSaveFailure = <E extends ErrorResponse>(error: E) =>
  createErrorAction(SharePointTypes.SHAREPOINT_SAVE_FAILURE, error);

export const setSelectedSite = (payload: Site | null) =>
  createAction(SharePointTypes.SHAREPOINT_SET_SELECTED_SITE, payload);

export const setSelectedDrive = (payload: Drive | null) =>
  createAction(SharePointTypes.SHAREPOINT_SET_SELECTED_DRIVE, payload);

export const setFolderPath = (payload: string) =>
  createAction(SharePointTypes.SHAREPOINT_SET_FOLDER_PATH, payload);

export const sharepointReset = () =>
  createAction(SharePointTypes.SHAREPOINT_RESET);
